import type { AdminChatMessage } from '../hooks/useAdminAgentChat';

const keyOf = (message: Pick<AdminChatMessage, 'role' | 'text'>) =>
  `${message.role}\u0000${message.text.trim()}`;

/**
 * Persisted history first, then this connection's live messages. A history message that the live
 * list already holds (same role and text) is dropped so nothing shows twice; when the socket
 * reconnects and the live list starts empty, the full history is shown again.
 */
export function mergeChatHistory(
  history: AdminChatMessage[],
  live: AdminChatMessage[]
): AdminChatMessage[] {
  const liveCounts = new Map<string, number>();
  for (const message of live) {
    liveCounts.set(keyOf(message), (liveCounts.get(keyOf(message)) ?? 0) + 1);
  }
  const olderThanLive = history.filter((message) => {
    const count = liveCounts.get(keyOf(message)) ?? 0;
    if (count === 0) return true;
    liveCounts.set(keyOf(message), count - 1);
    return false;
  });
  return [...olderThanLive, ...live];
}
